/* Haki search drawer (sections/haki-header.liquid → .haki-search). Loaded deferred.
 *
 * Two states:
 *  - EMPTY (input blank): server-rendered in the header (series tiles, Dropping now,
 *    MOTW + Magazine). JS only fills "Recent searches" from localStorage.
 *  - TYPING: one fetch of the section-rendered payload
 *      /search/suggest?q=…&section_id=haki-search-suggest   (sections/haki-search-suggest.liquid)
 *    which carries products WITH ships-by dates and, for character names, the series
 *    takeover (snippets/haki-search-aliases.liquid). JS renders it into ONE listbox.
 *
 * a11y: the input is a combobox (aria-controls the listbox, aria-activedescendant points
 * at the active option). ArrowDown/ArrowUp move through the VISIBLE options and wrap,
 * Enter opens the active option, Escape clears the active option first and closes the
 * drawer second. Options hold no focusable content; they navigate on click/Enter.
 *
 * The pure helpers below are unit-tested: tests/search-pick-products.test.js slices the
 * tokens…plural block by its 4-space-indented function lines, and require()s this file.
 */
(function () {
  'use strict';

    // Does a product really match what was typed? Shopify's predictive API pads
    // every answer with ~8 loosely related products (e.g. "xyzzy" -> a hat, a tee,
    // a hoodie), so a product counts only if some word of its title, tags, type,
    // vendor or description starts with a typed word (2+ letters).
    function tokens(q){ return String(q || '').toLowerCase().split(/[^a-z0-9]+/).filter(function(t){ return t.length >= 2; }); }
    // A product word matches a typed word when it starts with it ("hood" ->
    // hoodie). A word from a matched collection also matches the other way round,
    // so the Tees collection ("tees") matches a product word "tee".
    function productMatches(p, toks, collToks) {
      if (!toks.length) return true;
      var hay = [p.title, (p.tags || []).join(' '), p.type, p.vendor, String(p.body || '').replace(/<[^>]*>/g, ' ')]
        .join(' ').toLowerCase().split(/[^a-z0-9]+/);
      return hay.some(function(w){
        if (!w) return false;
        return toks.some(function(t){ return w.indexOf(t) === 0; }) ||
               (w.length >= 3 && collToks.some(function(t){ return w.indexOf(t) === 0 || t.indexOf(w) === 0; }));
      });
    }
    function productKey(p){ return String((p && (p.url || p.id)) || '').split('?')[0]; }
    // Which products to show. Match words = the typed words plus the words of any
    // collection the query matched ("jujutsu" -> Jujutsu Kaisen, handle jjk ->
    // products tagged jjk). If 1+ products match, show only those. If none match
    // but a collection, article or suggestion confirms the term (e.g. "jorts"),
    // show Shopify's own list. If nothing matches at all: zero-results state.
    // `pinned` (optional) = the series-takeover products ("gojo" -> JJK pieces): they
    // lead, count as matches, and true matches fill the rest (deduped by url). Shopify's
    // unrelated padding is never added after pinned products.
    function pickProducts(q, products, queries, colls, arts, limit, pinned) {
      var toks = tokens(q), collToks = [];
      colls.forEach(function(c){ collToks = collToks.concat(tokens(c.handle || ''), tokens(c.title || '')); });
      var matched = products.filter(function(p){ return productMatches(p, toks, collToks); });
      if (pinned && pinned.length) {
        var seen = {}, out = [];
        pinned.concat(matched).forEach(function(p){
          var k = productKey(p);
          if (out.length >= limit || seen[k]) return;
          seen[k] = 1; out.push(p);
        });
        return out;
      }
      if (matched.length) return matched.slice(0, limit);
      if (queries.length || colls.length || arts.length) return products.slice(0, limit);
      return [];
    }
    function plural(n, one, many){ return n + ' ' + (n === 1 ? one : many); }

  // Twin of snippets/haki-display-title.liquid and window.hakiDisplayTitle.
  function displayTitle(t) {
    return String(t == null ? '' : t).replace(/^\s*(?:\[\s*pre-?order\s*\]|pre-?order\s*[-–—])\s*/i, '');
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  // "one pi" + "one piece hoodie" -> "one pi<b>ece hoodie</b>": the part the shopper
  // has NOT typed yet is bold. A suggestion that doesn't start with the query is bold whole.
  function boldCompletion(text, q) {
    var t = String(text || ''), typed = String(q || '').trim();
    if (typed && t.toLowerCase().indexOf(typed.toLowerCase()) === 0) {
      var rest = t.slice(typed.length);
      return esc(t.slice(0, typed.length)) + (rest ? '<b>' + esc(rest) + '</b>' : '');
    }
    return '<b>' + esc(t) + '</b>';
  }
  var RECENT_MAX = 5;
  // Newest first, case-insensitive dedupe, max 5. Pure: returns a new list.
  function recentAdd(list, q) {
    var term = String(q || '').replace(/\s+/g, ' ').trim();
    var out = (list || []).filter(function(x){ return String(x).toLowerCase() !== term.toLowerCase(); });
    if (term) out.unshift(term.slice(0, 80));
    return out.slice(0, RECENT_MAX);
  }
  // May a suggest response be drawn? Only if it is the newest request (seq) AND it was
  // asked for exactly what is in the box now. A slow "luffy" answer that lands after the
  // shopper has typed "xyzzy" must be dropped, not painted over the newer query.
  function isCurrentResponse(req, cur) {
    return !!req && !!cur && req.seq === cur.seq &&
      String(req.q || '').trim() === String(cur.value || '').trim();
  }
  function fill(tpl, vars) { return String(tpl || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, k){ return vars[k] == null ? '' : vars[k]; }); }

  var api = { tokens: tokens, productMatches: productMatches, pickProducts: pickProducts, displayTitle: displayTitle,
    boldCompletion: boldCompletion, recentAdd: recentAdd, esc: esc, fill: fill, isCurrentResponse: isCurrentResponse };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (typeof document === 'undefined') return;

  var RECENT_KEY = 'haki_recent_searches';
  function recentList() {
    try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v.slice(0, RECENT_MAX) : []; }
    catch (e) { return []; }
  }
  function recentSave(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {} }

  function init() {
    var searchToggle = document.querySelector('[data-haki-search-toggle]');
    var searchPanel = document.querySelector('[data-haki-search]');
    if (!searchToggle || !searchPanel || searchPanel.getAttribute('data-hs-ready')) return;
    searchPanel.setAttribute('data-hs-ready', '1');
    var $ = function (sel) { return searchPanel.querySelector(sel); };
    var sDialog = $('.haki-search__panel');
    var sOverlay = $('[data-haki-search-overlay]');
    var sForm = $('.haki-search__form');
    var sInput = $('[data-haki-search-input]');
    var sClose = $('[data-haki-search-close]');
    var sClear = $('[data-haki-search-clear]');
    var sDefault = $('[data-search-default]');
    var sResults = $('[data-search-results]');
    var sListbox = $('[data-search-listbox]');
    var sStatus = $('[data-haki-search-status]');
    var sViewAll = $('[data-search-viewall]');
    var sNone = $('[data-search-none]');
    var sNoneTerm = $('[data-search-none-term]');
    var sRecent = $('[data-search-recent]');
    var sRecentList = $('[data-search-recent-list]');
    var sRecentClear = $('[data-search-recent-clear]');
    var G = {
      series: $('[data-g="series"]'), sugg: $('[data-g="sugg"]'), chips: $('[data-g="chips"]'),
      essay: $('[data-g="essay"]'), prods: $('[data-g="prods"]')
    };
    var suggLimit = parseInt(searchPanel.getAttribute('data-suggestions'), 10) || 6;
    var prodLimit = parseInt(searchPanel.getAttribute('data-products'), 10) || 8;
    var T = {};
    try { T = JSON.parse(searchPanel.getAttribute('data-i18n') || '{}'); } catch (e) {}
    var lastFocus = null, activeEl = null, lastQ = '';

    // Narrow screens get the short placeholder; tracked live because the theme editor
    // resizes the preview without reloading.
    var mobPlaceholder = searchPanel.getAttribute('data-placeholder-mobile');
    if (sInput && mobPlaceholder) {
      var deskPlaceholder = sInput.placeholder;
      var mqMobile = window.matchMedia('(max-width: 749px)');
      var applyPlaceholder = function () { sInput.placeholder = mqMobile.matches ? mobPlaceholder : deskPlaceholder; };
      applyPlaceholder();
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', applyPlaceholder);
    }

    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.setAttribute('aria-controls', 'haki-search-drawer');
    searchPanel.id = 'haki-search-drawer';

    function openSearch() {
      lastFocus = document.activeElement;
      searchPanel.hidden = false;
      searchPanel.setAttribute('aria-hidden', 'false');
      searchToggle.setAttribute('aria-expanded', 'true');
      renderRecent();
      // Double rAF: the browser must paint the un-hidden closed state once,
      // otherwise Safari skips the open transition entirely.
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ searchPanel.classList.add('is-open'); }); });
      // Lock the page (the real scroller is <html>) the same way the cart does.
      var comp = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--hk-scrollbar-comp', comp + 'px');
      document.documentElement.classList.add('haki-search-open');
      document.body.classList.add('haki-search-open');
      if (sInput) setTimeout(function(){ sInput.focus(); }, 120);
    }
    function closeSearch() {
      searchPanel.classList.remove('is-open');
      setActive(null);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-expanded', 'false');
      setExpanded(false);
      document.documentElement.classList.remove('haki-search-open');
      document.body.classList.remove('haki-search-open');
      document.documentElement.style.removeProperty('--hk-scrollbar-comp');
      setTimeout(function(){ if (!searchPanel.classList.contains('is-open')) searchPanel.hidden = true; }, 520);
    }
    searchToggle.addEventListener('click', function(){
      searchPanel.classList.contains('is-open') ? closeSearch() : openSearch();
    });
    if (sClose) sClose.addEventListener('click', closeSearch);
    if (sOverlay) sOverlay.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e){
      if (!searchPanel.classList.contains('is-open') || e.defaultPrevented) return;
      if (e.key === 'Escape') { closeSearch(); return; }
      // Keep Tab focus inside the dialog while it's open
      if (e.key === 'Tab' && sDialog) {
        var focusables = Array.prototype.filter.call(
          sDialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'),
          function(el){ return !el.hidden && el.offsetParent !== null; }
        );
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // ----- combobox / listbox -----
    function setExpanded(on) { if (sInput) sInput.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    // An option counts only if it is rendered: CSS hides result cards 5-8 at <750px, and a
    // hidden group's wrapper hides all of its options. Arrow keys AND the live-region
    // counts use this one filter, so a screen reader never hears about cards it can't reach.
    function shownOptions(root) {
      if (!root || (sResults && sResults.hidden)) return [];
      return Array.prototype.filter.call(root.querySelectorAll('[role="option"]'), function(o){ return o.offsetParent !== null; });
    }
    function visibleOptions() { return shownOptions(sListbox); }
    function setActive(el) {
      if (activeEl) { activeEl.classList.remove('is-active'); activeEl.setAttribute('aria-selected', 'false'); }
      activeEl = el || null;
      if (activeEl) {
        activeEl.classList.add('is-active');
        activeEl.setAttribute('aria-selected', 'true');
        if (sInput) sInput.setAttribute('aria-activedescendant', activeEl.id);
        if (activeEl.scrollIntoView) activeEl.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } else if (sInput) {
        sInput.removeAttribute('aria-activedescendant');
      }
    }
    function move(delta) {
      var opts = visibleOptions();
      if (!opts.length) return;
      var i = opts.indexOf(activeEl);
      var next = i < 0 ? (delta > 0 ? 0 : opts.length - 1) : (i + delta + opts.length) % opts.length;
      setActive(opts[next]);
    }
    function go(opt) {
      if (!opt) return;
      var href = opt.getAttribute('data-href');
      if (!href) return;
      remember(opt.getAttribute('data-q') || lastQ);
      window.location.href = href;
    }
    if (sInput) sInput.addEventListener('keydown', function(e){
      if (e.isComposing) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!visibleOptions().length) return;
        e.preventDefault();
        move(e.key === 'ArrowDown' ? 1 : -1);
      } else if (e.key === 'Enter' && activeEl) {
        e.preventDefault();
        go(activeEl);
      } else if (e.key === 'Escape' && activeEl) {
        e.preventDefault(); // first Escape only leaves the list; the next one closes
        setActive(null);
      }
    });
    if (sListbox) {
      sListbox.addEventListener('click', function(e){
        var opt = e.target.closest ? e.target.closest('[role="option"]') : null;
        if (opt) { e.preventDefault(); go(opt); }
      });
      // Hover is visual only: it must not move aria-activedescendant, or a screen reader
      // announces whatever the pointer happens to cross while the user is typing.
      var hoverEl = null;
      var setHover = function (el) {
        if (hoverEl === el) return;
        if (hoverEl) hoverEl.classList.remove('is-hover');
        hoverEl = el || null;
        if (hoverEl) hoverEl.classList.add('is-hover');
      };
      sListbox.addEventListener('mousemove', function(e){
        setHover(e.target.closest ? e.target.closest('[role="option"]') : null);
      });
      sListbox.addEventListener('mouseleave', function(){ setHover(null); });
    }
    if (sForm) sForm.addEventListener('submit', function(){ remember(sInput && sInput.value); });

    // ----- recent searches -----
    function remember(q) { if (q && String(q).trim()) recentSave(recentAdd(recentList(), q)); }
    function renderRecent() {
      if (!sRecent || !sRecentList) return;
      var list = recentList();
      sRecentList.innerHTML = list.map(function(q){
        return '<li><a class="haki-search__recent-link" href="/search?q=' + encodeURIComponent(q) + '">' + esc(q) + '</a></li>';
      }).join('');
      sRecent.hidden = !list.length;
    }
    if (sRecentClear) sRecentClear.addEventListener('click', function(){
      recentSave([]); renderRecent();
      if (sInput) sInput.focus();
      if (sStatus) sStatus.textContent = T.recent_cleared || '';
    });
    if (sRecentList) sRecentList.addEventListener('click', function(e){
      var a = e.target.closest ? e.target.closest('a') : null;
      if (a) remember(a.textContent);
    });

    function showDefault() {
      searchSeq++; // drop any in-flight response so it can't overwrite the empty state
      setActive(null);
      setExpanded(false);
      lastQ = '';
      if (sDefault) sDefault.hidden = false;
      if (sResults) sResults.hidden = true;
      if (sClear) sClear.hidden = true;
      if (sStatus) sStatus.textContent = '';
      renderRecent();
    }

    var debounce, searchSeq = 0, inflight = null;
    function onType() {
      var q = (sInput.value || '').trim();
      if (sClear) sClear.hidden = q.length === 0;
      setActive(null);
      // Every keystroke retires the request in flight: its answer is for an older query.
      searchSeq++;
      if (inflight) { inflight.abort(); inflight = null; }
      if (!q) { clearTimeout(debounce); showDefault(); return; }
      clearTimeout(debounce);
      debounce = setTimeout(function(){ runSearch(q); }, 220);
    }

    var optN = 0;
    function opt(cls, href, inner, extra) {
      return '<div role="option" aria-selected="false" id="hs-opt-' + (++optN) + '" class="hs-opt ' + cls + '" data-href="' + esc(href) + '"' + (extra || '') + '>' + inner + '</div>';
    }
    function badgeText(p) {
      if (p.badge === 'soldout') return T.sold_out || 'Sold out';
      if (p.badge === 'preorder') return p.ships_by ? fill(T.ships_by, { date: p.ships_by }) : (T.pre_order || 'Pre-order');
      return '';
    }
    function card(p) {
      var b = badgeText(p);
      var title = p.display_title || displayTitle(p.title);
      return opt('hs-card', p.url,
        '<span class="hs-card__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="600" height="750">' : '') + '</span>' +
        '<span class="hs-card__name">' + esc(title) + '</span>' +
        '<span class="hs-card__price">' + esc(p.price) + '</span>' +
        (b ? '<span class="hs-badge' + (p.badge === 'soldout' ? ' hs-badge--soldout' : '') + '">' + esc(b) + '</span>' : ''));
    }
    function setGroup(g, html) {
      if (!g) return;
      g.innerHTML = html;
      var wrap = g.closest('[data-gwrap]') || g;
      wrap.hidden = !html;
    }

    function render(q, data) {
      optN = 0;
      setActive(null);
      lastQ = q;
      var series = data.series || null;
      // Predictive search tags URLs with ?_pos=…&_psq=…; the series link is a plain collection link.
      if (series) series.url = String(series.url || '').split('?')[0];
      var pinned = series ? (data.series_products || []) : [];
      var queries = (data.queries || []).slice(0, suggLimit);
      var colls = (data.collections || []).slice(0, 6);
      if (series) colls = [series].concat(colls.filter(function(c){ return c.handle !== series.handle; }));
      var arts = (data.articles || []).slice(0, 1);
      var shown = pickProducts(q, data.products || [], queries, colls, arts, prodLimit, pinned);
      var none = !series && !queries.length && !colls.length && !arts.length && !shown.length;

      setGroup(G.series, series ? opt('hs-takeover', series.url,
        '<span class="hs-takeover__img">' + (series.img ? '<img src="' + esc(series.img) + '" alt="" width="480" height="600">' : '') + '</span>' +
        '<span class="hs-takeover__txt"><span class="hs-eyebrow">' + esc(T.series || 'Series') + '</span>' +
        '<span class="hs-takeover__title">' + esc(series.title) + '</span>' +
        '<span class="hs-takeover__meta">' + esc(fill(series.count === 1 ? T.piece : T.pieces, { count: series.count })) +
        ' <span class="hs-takeover__cta">' + esc(T.shop_all || 'Shop all') + '</span></span></span>') : '');
      setGroup(G.sugg, queries.map(function(s){
        return opt('hs-sugg', s.url, boldCompletion(s.text, q), ' data-q="' + esc(s.text) + '"');
      }).join(''));
      // The takeover banner already links the series, so its chip would be a duplicate.
      setGroup(G.chips, colls.filter(function(c){ return !series || c.handle !== series.handle; })
        .map(function(c){ return opt('hs-chip', c.url, esc(c.title)); }).join(''));
      setGroup(G.essay, arts.map(function(a){
        return opt('hs-essay', a.url,
          '<span class="hs-essay__img">' + (a.img ? '<img src="' + esc(a.img) + '" alt="" loading="lazy" width="400" height="500">' : '') + '</span>' +
          '<span class="hs-essay__txt"><span class="hs-eyebrow">' + esc(T.magazine || 'Haki Magazine') + '</span><span class="hs-essay__title">' + esc(a.title) + '</span></span>');
      }).join(''));
      setGroup(G.prods, shown.map(card).join(''));
      // Desktop: with nothing in the left column, products take the full width.
      var cols = sListbox && sListbox.querySelector('.hs-cols');
      if (cols) cols.classList.toggle('hs-cols--full', !queries.length && !arts.length && !(G.chips && G.chips.innerHTML));

      if (sViewAll) {
        if (series) {
          sViewAll.href = series.url;
          sViewAll.textContent = fill(T.see_all_count, { count: series.count });
        } else {
          sViewAll.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
          sViewAll.textContent = T.see_all || 'See all results';
        }
        sViewAll.hidden = none;
      }
      if (sNoneTerm) sNoneTerm.textContent = q;
      if (sNone) sNone.hidden = !none;
      if (sListbox) sListbox.hidden = none;
      if (sDefault) sDefault.hidden = true;
      if (sResults) sResults.hidden = false;
      setExpanded(!none);

      // Live region: counts only, so it isn't chatty while typing.
      if (sStatus) {
        if (none) { sStatus.textContent = fill(T.no_results, { terms: q }); }
        else {
          // Count what is ON SCREEN, not what was rendered: at 390 only 4 of 8 cards show,
          // and the series takeover is announced on its own (it has no chip).
          var nSugg = shownOptions(G.sugg).length, nColl = shownOptions(G.chips).length,
            nArt = shownOptions(G.essay).length, nProd = shownOptions(G.prods).length;
          var parts = [];
          if (series) parts.push(series.title + ': ' + fill(series.count === 1 ? T.piece : T.pieces, { count: series.count }));
          if (nSugg) parts.push(plural(nSugg, 'suggestion', 'suggestions'));
          if (nColl) parts.push(plural(nColl, 'collection', 'collections'));
          if (nArt) parts.push(plural(nArt, 'article', 'articles'));
          if (nProd) parts.push(plural(nProd, 'product', 'products'));
          sStatus.textContent = parts.join(', ') + '. ' + (T.arrows_hint || '');
        }
      }
    }

    function runSearch(q, retried) {
      var seq = ++searchSeq;
      if (inflight) inflight.abort();
      var ctrl = inflight = (typeof AbortController === 'function') ? new AbortController() : null;
      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=query,product,collection,article&resources[limit]=10' +
        '&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=haki-search-suggest';
      fetch(url, { headers: { 'Accept': 'text/html' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function(r){
          if (r.status === 429 && !retried) {
            var wait = Math.min(2000, (parseFloat(r.headers.get('Retry-After')) || 1) * 1000);
            setTimeout(function(){ if (seq === searchSeq) runSearch(q, true); }, wait);
            return null;
          }
          if (!r.ok) throw new Error('search ' + r.status);
          return r.text();
        })
        .then(function(html){
          if (ctrl && inflight === ctrl) inflight = null;
          // A newer keystroke (or a clear) superseded this, or the box no longer says q.
          if (html == null || !isCurrentResponse({ seq: seq, q: q }, { seq: searchSeq, value: sInput ? sInput.value : '' })) return;
          var m = html.match(/<script type="application\/json" data-hk-suggest>([\s\S]*?)<\/script>/);
          if (!m) throw new Error('no payload');
          render(q, JSON.parse(m[1]));
        })
        .catch(function(err){
          // Aborted = a newer keystroke took over; nothing to do. A real failure for the
          // CURRENT query must not leave the previous query's results under the new text:
          // fall back to the empty-state content (Enter still submits to /search).
          if ((err && err.name === 'AbortError') || seq !== searchSeq) return;
          setActive(null);
          setExpanded(false);
          if (sResults) sResults.hidden = true;
          if (sDefault) sDefault.hidden = false;
          if (sStatus) sStatus.textContent = T.unavailable || '';
        });
    }
    if (sInput) sInput.addEventListener('input', onType);
    if (sClear) sClear.addEventListener('click', function(){ sInput.value = ''; sInput.focus(); showDefault(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
